import configuration from '@/taskpane/common/configuration'

export default function officeApiIsRequirementSetSupported(requirementSet: string) {
  return configuration.SUPPORTED_REQUIREMENT_SETS.includes(requirementSet)
}
